import './Header.css';
import { Link } from 'react-router-dom';
import { useContext, useMemo } from 'react';
import { useDevice } from '../hooks/useDevise';
import { UserProviderValue } from '../models';
import { UserContext } from '../contexts/user.context';
import { formatNumber, getFriendlyDate, getFriendlyName, getFriendlyPublicKey, getLinkWithParams } from '../utils';
import { Separation } from './ui';
import Skeleton from 'react-loading-skeleton';

export function Header() {
   const { wallet, isAuthenticated, user, balance, logOut, setIsLoginModalOpen } = useContext<UserProviderValue>(UserContext);
   const { isMobile } = useDevice();
   const name = useMemo(() => getFriendlyName(user), [user]);

   return (
      <header className="flex flex-col items-center">
         <div className="header-content w-100 flex gap wrap justify-between items-center">
            {!isMobile && (
               <div className="flex items-center gap-4">
                  {user && (
                     <div className="flex gap-2">
                        <Link
                           className=""
                           to={getLinkWithParams('/account')}>
                           <div className="flex items-center gap-1">
                              <img
                                 className="round-image"
                                 src={user.image ?? '/assets/icons/user-icon.png'}
                                 alt=""
                                 width={isMobile ? 35 : 40}
                                 height={isMobile ? 35 : 40}
                              />
                              <div className="flex flex-col">
                                 <h3>Welcome{name ? `, ${name}!` : ''}</h3>
                                 {user.createdAt && (
                                    <span className="small gray">
                                       Member since: <span className="white">{getFriendlyDate(user.createdAt, true)}</span>
                                    </span>
                                 )}
                              </div>
                           </div>
                        </Link>
                        <Separation direction="vertical" />
                        <div className="flex items-center gap-1">
                           <img
                              className="currency-icon"
                              src="/assets/icons/xp-icon.png"
                              alt=""
                              width={isMobile ? 30 : 35}
                              height={isMobile ? 30 : 35}
                           />
                           {!balance ? <Skeleton /> : <h3 className="green">{formatNumber(balance?.points ?? 0)} XP</h3>}
                        </div>
                     </div>
                  )}
               </div>
            )}
            <Link
               className={`logo ${isMobile ? 'mobile' : ''}`}
               to={`${wallet?.publicKey && isAuthenticated ? getLinkWithParams('/home') : getLinkWithParams('/')}`}>
               <img
                  src="/assets/images/golfn-logo.png"
                  alt="GolfN"
                  width={isMobile ? 80 : 100}
               />
            </Link>

            <div>
               {!isMobile ? (
                  <div className="flex items-center gap-4">
                     {isAuthenticated ? (
                        <div className="flex items-center gap-2">
                           {user && (
                              <div className="flex items-center gap-1">
                                 <Link
                                    className="with-bg flex items-center gap-1"
                                    to={getLinkWithParams('/account')}>
                                    <img
                                       src="/assets/icons/email-icon.svg"
                                       alt=""
                                       width={18}
                                    />
                                    {user.email ?? 'Link Email'}
                                 </Link>
                                 <Link
                                    className="with-bg flex items-center gap-1"
                                    to={getLinkWithParams('/account')}>
                                    <img
                                       src="/assets/icons/wallet-icon.svg"
                                       alt=""
                                       width={18}
                                    />
                                    {getFriendlyPublicKey(user) || 'Link Wallet'}
                                 </Link>
                              </div>
                           )}
                           <Link
                              className="with-bg flex items-center gap-1"
                              to={getLinkWithParams('/')}
                              onClick={logOut}>
                              <img
                                 src="/assets/icons/logout-icon.svg"
                                 alt=""
                                 width={20}
                              />
                              Log Out
                           </Link>
                        </div>
                     ) : (
                        <Link
                           className="with-bg flex items-center gap-1"
                           to={getLinkWithParams('')}
                           onClick={() => setIsLoginModalOpen(true)}>
                           <img
                              src="/assets/icons/user-icon.svg"
                              alt=""
                              width={18}
                           />
                           {'Login'}
                        </Link>
                     )}
                  </div>
               ) : isAuthenticated ? (
                  <div className="flex items-center gap-1">
                     <img
                        className="currency-icon"
                        src="/assets/icons/xp-icon.png"
                        alt=""
                        width={isMobile ? 30 : 40}
                        height={isMobile ? 30 : 40}
                     />
                     <h3 className="green">{formatNumber(balance?.points ?? 0)} XP</h3>
                  </div>
               ) : (
                  <Link
                     className="with-bg flex items-center gap-1"
                     to={getLinkWithParams('')}
                     onClick={() => setIsLoginModalOpen(true)}>
                     <img
                        src="/assets/icons/user-icon.svg"
                        alt=""
                        width={18}
                     />
                     {'Login'}
                  </Link>
               )}
            </div>
         </div>
      </header>
   );
}
